import { render, staticRenderFns } from "./WebRatingFeaturePage.vue?vue&type=template&id=01437cd5&"
import script from "./WebRatingFeaturePage.vue?vue&type=script&lang=js&"
export * from "./WebRatingFeaturePage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports